function shareContent() {
  if (navigator.share) {
    navigator.share({
      title: 'Check this out!',
      text: 'Look at this cool content.',
      url: window.location.href
    })
  } else {
    alert('Sharing not supported on this browser. Please copy the link manually.');
  }
}

window.openSizeModal = function() {
  const modal = document.getElementById("mecnexSizeModal");
  if(modal) {
    modal.style.display = "block";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modal.classList.add("show");
      });
    });
    document.body.style.overflow = "hidden"; 
  } else {
    console.error("Modal ID 'mecnexSizeModal' nahi mila!"); 
  }
}

window.closeSizeModal = function() {
  const modal = document.getElementById("mecnexSizeModal");
  if(modal) {
    modal.classList.remove("show");
    setTimeout(() => {
      modal.style.display = "none";
    }, 400); 
    document.body.style.overflow = "auto"; 
  }
}